export var AvatarSize;
(function (AvatarSize) {
  AvatarSize["Medium"] = "medium";
  AvatarSize["Large"] = "large";
})(AvatarSize || (AvatarSize = {}));
export var TooltipAlignment;
(function (TooltipAlignment) {
  TooltipAlignment["Left"] = "left";
  TooltipAlignment["Center"] = "center";
  TooltipAlignment["Right"] = "right";
})(TooltipAlignment || (TooltipAlignment = {}));